import MainContainer from "../../layout/MainContainer";
import { Card, Box } from "@mui/material";

import Banner from "../../features/banner/Banner";

const ManageBanner = () => {
  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Manage Banner</h1>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Banner />
          </Box>
        </Card>
      </div>
    </MainContainer>
  );
};

export default ManageBanner;
